const ALL_ACCESS_ROLE_LIST = [0, 1] // 0: Sys Admin, 1: App Manager

// Determines whether the current session is allowed to access a route.
export function canAccessRoute(route, session) {
  if (!route?.requireAdmin) {
    return true
  }

  const user = session?.user
  if (!user) {
    return false
  }

  const leastPrivilege = Number(route.leastPrivilege)
  const userGroupType = Number(route.userGroupType)
  const staffRole = Number(user.staff_role)

  if (userGroupType === -1 || ALL_ACCESS_ROLE_LIST.includes(staffRole)) {
    return true
  }

  return (
    staffRole <= leastPrivilege &&
    Number(user.staff_group_type) === userGroupType
  )
}
